/* ==============================================================================================
 * INITIALIZE APP
 * ============================================================================================== */

var Sushi;

(function (Sushi) {
	"use strict";

	if (Sushi.Util.detectIe()) {
		document.documentElement.classList.add("ie");
	}

})(Sushi || (Sushi = {}));
